import React from 'react';

import Start from '../templates/start';

const Page = () => <Start locale="da" />;

export default Page;
